@use '../../style/functions';

/**
 * @prop --lime-grid-area: Grid layout
 * @prop --lime-grid-columns: Number of columns in the grid, defaults to 4
 * @prop --lime-grid-cell-height: Height of grid cells, defaults to `2.5rem` (40px)
 * @prop --lime-grid-gutter: width of the gutter between columns and rows, defaults to `1rem` (16px) - see https://material.io/design/layout/responsive-layout-grid.html#breakpoints for guidelines
 */

:host {
    display: block;
    position: relative;
}

:host([hidden]) {
    display: none;
}

slot {
    display: grid;
    grid-template-areas: var(--lime-grid-area, '');
    grid-template-columns: repeat(var(--lime-grid-columns, 4), minmax(0, 1fr));
    gap: var(--lime-grid-gutter, functions.pxToRem(16));
    grid-auto-flow: row dense;
    grid-auto-rows: var(--lime-grid-cell-height, functions.pxToRem(40));
    margin: 0;
    height: 100%;
    width: 100%;
}
